import { Cigarette } from "lucide-react";
import { useTranslation } from "react-i18next";
import { BaseMetricLogCard } from "@/core/components/tracking";
import { updateCigaretteCount } from "@/lib/api";
import { useProductContext } from "@/contexts/ProductContext";

interface CigaretteLogCardProps {
  onComplete?: () => void;
  onDataUpdate?: () => void;
  isLoading?: boolean;
  externalOpen?: boolean;
  onExternalOpenChange?: (open: boolean) => void;
}

export function CigaretteLogCard({ onComplete, onDataUpdate, isLoading, externalOpen, onExternalOpenChange }: CigaretteLogCardProps) {
  const { t } = useTranslation();
  const { currentProduct } = useProductContext();

  return (
    <BaseMetricLogCard
      // Display
      icon={Cigarette}
      gradientClasses="from-red-500 to-orange-600"
      borderHoverClasses="hover:border-red-500/40"

      // Input type
      inputType="text"

      // Data field
      fieldName="cigarettes_smoked"

      // Validation
      minValue={0}

      // Pre-translated strings
      cardTitle={t('mindcotine:actions.logCigarettes', 'Log Cigarettes')}
      cardDescription={t('mindcotine:actions.cigarettesHelp', 'Track cigarettes smoked')}
      dialogTitle={t('mindcotine:actions.logCigarettes', 'Log Cigarettes')}
      dialogDescription={t('mindcotine:actions.cigarettesHelp', 'Track cigarettes smoked')}
      inputLabel={t('mindcotine:actions.countFor', 'Count for')}
      inputPlaceholder="0"
      notesPlaceholder={t('mindcotine:actions.notesPlaceholder', 'Add any notes...')}
      loggedTitle={t('mindcotine:actions.cigarettesLogged', 'Cigarettes Logged')}
      loggedDescription={t('mindcotine:actions.cigarettesLoggedDescription', 'Your cigarettes have been recorded.')}
      errorInvalidInput={t('common:errors.invalidInput', 'Invalid Input')}
      errorInvalidValue={t('common:errors.invalidNumber', 'Please enter a valid number.')}

      // Analytics
      analyticsEvent="Cigarettes Logged"

      // Popup triggers
      popupTriggers={[
        { trigger: "cigarette_logged" }
      ]}

      // API function
      updateFunction={updateCigaretteCount}

      // Callbacks
      onComplete={onComplete}
      onDataUpdate={onDataUpdate}
      isLoading={isLoading}
      externalOpen={externalOpen}
      onExternalOpenChange={onExternalOpenChange}

      // Product context
      productId={currentProduct}
    />
  );
}
